import dayjs from "dayjs";
import JSZip from "jszip";
import SparkMD5 from "spark-md5";

export const getFileMD5 = async (file) => {
  const buffer = await file.arrayBuffer();
  return SparkMD5.ArrayBuffer.hash(buffer);
};

export const getDynamicChunkSize = (fileSize) => {
  const MIN = 2 * 1024 * 1024;
  const MAX = 20 * 1024 * 1024;
  const ideal = Math.ceil(fileSize / 10);
  return Math.min(Math.max(ideal, MIN), MAX);
};

export const getChunkSizeByBandWidth = (chunkUploadTime, currentChunkSize) => {
  // Note: calculating estimatedChunkSizeInDefinedTime in kb/s
  chunkUploadTime = chunkUploadTime / 1000; // converting ms to seconds
  var sizeUploadedInKB = currentChunkSize / 1024; // converting chunk size from bytes to KB
  currentChunkSize = currentChunkSize / (1024 * 1024); // converting bytes to MB
  var maxChunkSizeInMB = 20;
  var minChunkSizeInMB = 6;

  var estimatedChunkSizeInDefinedTime =
    (sizeUploadedInKB * 30) / chunkUploadTime; // formula : (size uploaded * 30 / time taken to upload the chunk)
  var nextChunk =
    currentChunkSize * 2 > maxChunkSizeInMB
      ? maxChunkSizeInMB
      : currentChunkSize * 2;
  var previousChunk =
    currentChunkSize == maxChunkSizeInMB
      ? 16
      : currentChunkSize / 2 <= minChunkSizeInMB
        ? minChunkSizeInMB
        : currentChunkSize / 2;

  if (
    estimatedChunkSizeInDefinedTime / 1024 > currentChunkSize &&
    estimatedChunkSizeInDefinedTime / 1024 >= nextChunk
  ) {
    currentChunkSize = nextChunk;
  } else if (estimatedChunkSizeInDefinedTime / 1024 < currentChunkSize) {
    currentChunkSize = previousChunk;
  } else {
    console.log(
      "no change in chunk size, using the existing chunk size",
      currentChunkSize,
    );
  }
  console.log("chunk size ==>>", currentChunkSize);
  return currentChunkSize * 1024 * 1024;
};

const months = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  10: "October",
  11: "November",
  12: "Decemeber",
};

const getExtension = (inp) => {
  return inp.split(".").pop();
};

const dateToWordConverter = (date, shortMonth = true) => {
  const dateItems = date.split("/");
  const transformedMonth = !shortMonth
    ? months[dateItems[1]]
    : months[dateItems[1]].split("").slice(0, 3).join("");
  const capitalizedMonth =
    transformedMonth.split("")[0].toUpperCase() +
    transformedMonth.split("").slice(1).join("");
  return `${dateItems[0]} ${capitalizedMonth} ${dateItems[2]}`;
};
// export const timeFormatMUI = (data) => {
//   let combinedStringTime = `${new Date().toDateString()} ${data}`;
//   let formatTime = dayjs(new Date(combinedStringTime));
//   return formatTime;
// };

export const timeFormatMUI = (data) => {
  // Check if the input data is valid
  if (isNaN(dayjs(data, "hh:mm A").valueOf())) {
    return null;
  }

  let combinedStringTime = `${new Date().toDateString()} ${data}`;
  let formatTime = dayjs(new Date(combinedStringTime));
  return formatTime;
};

export function convertDateFormat(inputDateString) {
  var parts = inputDateString.split("/");
  var date = new Date(parts[0], parts[1] - 1, parts[2]);
  var formattedDate =
    date.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2);
  return formattedDate;
}

export function convertRailwayTimeToStandardTime(railwayTime) {
  if (!railwayTime) return "";

  const parts = railwayTime.split(":");
  let hour = parseInt(parts[0], 10);
  const minute = parseInt(parts[1], 10);

  const meridiem = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  hour = hour === 0 ? 12 : hour;

  const formattedHour = ("0" + hour).slice(-2);
  const formattedMinute = ("0" + minute).slice(-2);

  return `${formattedHour}:${formattedMinute} ${meridiem}`;
}
// export { queryClient, months, getExtension, dateToWordConverter };

export const baseToImg = (base) => {
  return `data:image/jpeg;base64,${base}`;
};

// export const fileToBase = (file) => {
//   let document = "";
//   let reader = new FileReader();
//   reader.readAsDataURL(file);
//   reader.onload = function () {
//     document = reader.result;
//   };
//   reader.onerror = function (error) {
//
//   };

//   return document;
// };

let base64String = "";

export default function imageUploaded(file) {
  let reader = new FileReader();

  reader.onload = function () {
    base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
    return base64String;
  };
  reader.readAsDataURL(file);
}

export const fileToBase = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1]; // Extract base64 portion
      resolve(base64String);
    };
    reader.onerror = (error) => {
      reject(`Error converting file to base64: ${error}`);
    };
  });
};

export function basetoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export function downloadFile(file, fileName) {
  const link = document.createElement("a");
  link.href = file;
  link.download = fileName || "image";
  link.target = "_blank";
  link.rel = "noreferrer";
  link.click();
}
export const getFileNameFromDisposition = (res) => {
  const disposition = res ? res.headers.get("Content-Disposition") : null;
  if (!disposition) return "downloaded-file";
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(disposition);
  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, ""); // remove quotes
  }
  return "downloaded-file";
};

export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const makeZipImages = (imgData, folderName = "images") => {
  var zip = new JSZip();
  var img = zip.folder("event-images");
  for (let i = 0; i < imgData.length; i++) {
    // img.file(`image${i + 1}.png`, imgData[i]);
    img.file(imgData[i]?.filename, imgData[i]?.blob);
  }

  zip.generateAsync({ type: "blob" }).then((content) => {
    const url = window.URL.createObjectURL(content);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${folderName}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);
  });
};

export function convertToRailwayTime(time12) {
  const [timeStr, ampm] = time12.split(" ");
  const [hours, minutes] = timeStr.split(":");
  let hours24 = parseInt(hours);

  if (ampm === "PM" && hours24 !== 12) {
    hours24 += 12;
  } else if (ampm === "AM" && hours24 === 12) {
    hours24 = 0;
  }

  return `${hours24.toString().padStart(2, "0")}:${minutes}`;
}

export function todayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${year}/${month}/${day}`;
  return formattedDate;
}

export function convertJDSDateFormat(inputDateString) {
  var parts = inputDateString.split("-");

  if (parts.length > 1) {
    var date = new Date(parts[0], parts[1] - 1, parts[2]);
    var formattedDate =
      date.getFullYear() +
      "/" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "/" +
      ("0" + date.getDate()).slice(-2);
    return formattedDate;
  } else {
    return inputDateString;
  }
}

export const isoToInformalData = (dateStr) => {
  const date = new Date(dateStr);

  // Format the date
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = date
    .toLocaleDateString("en-GB", options)
    .replace(",", "");
  return formattedDate;
};

export function getLocalDate(isoString) {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
export function getArrtoDate(arrDate) {
  const date = new Date(
    arrDate[0], // year
    arrDate[1] - 1, // month (0-indexed)
    arrDate[2], // day
    arrDate[3],
    arrDate[4],
    arrDate[5],
    Math.floor(arrDate[6] / 1e6), // convert nanoseconds to milliseconds
  );

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function getLocalTime(isoString) {
  const date = new Date(isoString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

export function bytesToMB(bytes) {
  return bytes / 1000000;
}

export const imgValidationCheck = (event, file = null, maxSize) => {
  const selectedFile = file || event.target.files[0];
  if (!selectedFile) {
    return false;
  }
  const fileName = selectedFile.name.toLowerCase();

  // Split filename and extension
  const fileParts = fileName.split(".");
  const fileExtension = fileParts.pop().toLowerCase(); // Get the file extension
  const baseFileName = fileParts.join("."); // Join remaining parts to get the base filename

  // Validate file extension and double extensions
  const allowedExtensions = ["jpeg", "jpg", "png"];
  const doubleExtensions = fileExtension.split(".").length - 1;
  if (!allowedExtensions.includes(fileExtension) || doubleExtensions > 1) {
    return false;
  }

  // Validate against malicious file types
  const blockedExtensions = ["exe", "php", "py", "inf"];
  if (blockedExtensions.includes(fileExtension)) {
    return false;
  }

  // Validate file type (MIME type)
  const allowedMimeTypes = ["image/jpeg", "image/png"];
  if (!allowedMimeTypes.includes(selectedFile.type)) {
    return false;
  }

  // Validate against special characters in base file name
  const specialCharactersRegex = /[!@#$%^&*()+={}\[\]:;"'<>,.?/\\|]/;
  // if (specialCharactersRegex.test(baseFileName)) {
  //   return false;
  // }

  // Validate file size
  if (selectedFile.size <= 0) {
    return false;
  }
  if (bytesToMB(selectedFile.size).toFixed(1) > maxSize) {
    return false;
  }
  // Perform escaping for potential formula characters in file name
  if (
    baseFileName.startsWith("+") ||
    baseFileName.startsWith("-") ||
    baseFileName.startsWith("=") ||
    baseFileName.startsWith("@")
  ) {
    const escapedBaseFileName = `'${baseFileName}`;
    selectedFile.name = `${escapedBaseFileName}.${fileExtension}`;
    return false;
  }

  return true;
};

export const excelValidationCheck = (event) => {
  const selectedFile = event.target.files[0];
  const fileName = selectedFile.name.toLowerCase();

  // Split filename and extension
  const fileParts = fileName.split(".");
  const fileExtension = fileParts.pop().toLowerCase(); // Get the file extension
  const baseFileName = fileParts.join("."); // Join remaining parts to get the base filename
  // Validate file extension and double extensions
  const allowedExtensions = ["xlsx"];
  const doubleExtensions = fileExtension.split(".").length - 1;
  if (!allowedExtensions.includes(fileExtension) || doubleExtensions > 1) {
    return false;
  }

  // Validate against malicious file types
  const blockedExtensions = ["exe", "php", "py", "inf"];
  if (blockedExtensions.includes(fileExtension)) {
    return false;
  }

  // Validate file type (MIME type)
  const allowedMimeTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  if (!allowedMimeTypes.includes(selectedFile.type)) {
    return false;
  }

  // Validate against special characters in base file name
  const specialCharactersRegex = /[!@#$%^&*()+={}\[\]:;"'<>,.?/\\|]/;
  if (specialCharactersRegex.test(baseFileName)) {
    return false;
  }
  // Validate file size
  if (selectedFile.size <= 0) {
    return false;
  }
  // Perform escaping for potential formula characters in file name
  if (
    baseFileName.startsWith("+") ||
    baseFileName.startsWith("-") ||
    baseFileName.startsWith("=") ||
    baseFileName.startsWith("@")
  ) {
    const escapedBaseFileName = `'${baseFileName}`;
    selectedFile.name = `${escapedBaseFileName}.${fileExtension}`;
    return false;
  }

  return true;
};

export function validateFileSignature(file, signatures) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      const arr = new Uint8Array(e.target.result).subarray(0, 4); // Read only first 4 bytes
      let header = "";
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16).padStart(2, "0"); // Convert to hex string
      }

      // Check against all known signatures
      const isValid = Object.values(signatures).some((sigArr) =>
        sigArr.includes(header),
      );
      resolve(isValid);
    };

    reader.onerror = function () {
      reject("Error reading file");
    };

    reader.readAsArrayBuffer(file.slice(0, 4)); // Read only the first 4 bytes
  });
}

export function replaceMultipleSpaces(str) {
  return str ? str.replace(/\s+/g, " ").trim() : "";
}
export function obfuscateEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(email)) {
    return email; // Return the original value if the email is invalid
  }
  let [username, domain] = email.split("@");
  if (username.length <= 2) {
    return email;
  }
  let maskedUsername =
    username[0] +
    "*".repeat(username.length - 2) +
    username[username.length - 1];
  return maskedUsername + "@" + domain;
}
export function capitalizeWords(str, splitChar) {
  if (!str) return "";
  return str
    .split(splitChar || " ")
    .map((word) => word[0].toUpperCase() + word.toLowerCase().slice(1))
    .join(" ");
}

export function bytesToGB(bytes) {
  return bytes / 1024 ** 3; // or bytes / 1073741824
}

export function calculateDaysLeft(expiryDate) {
  // Current date
  const currentDate = new Date();

  // Convert the expiryDate to a Date object
  const expiryDateObj = new Date(expiryDate);

  // Calculate the difference in milliseconds
  const timeDifference = expiryDateObj - currentDate;

  // Convert milliseconds to days (1 day = 86400000 milliseconds)
  const daysLeft = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  return daysLeft;
}

export function removeUnderscore(text) {
  if (!text) return;
  return text.replace(/_/g, " "); // Removes all underscores
}

export function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split("=");
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}
export const getDeviceDetails = () => {
  const userAgent = navigator.userAgent;

  let platformType = null;
  let platformVersion = null;

  if (userAgent.includes("Edg/")) {
    platformType = "Edge";
    platformVersion = userAgent.match(/Edg\/([\d.]+)/)?.[1] || "";
  } else if (userAgent.includes("Chrome/")) {
    platformType = "Chrome";
    platformVersion = userAgent.match(/Chrome\/([\d.]+)/)?.[1] || "";
  } else if (userAgent.includes("Firefox/")) {
    platformType = "Firefox";
    platformVersion = userAgent.match(/Firefox\/([\d.]+)/)?.[1] || "";
  } else if (userAgent.includes("Safari/")) {
    platformType = "Safari";
    platformVersion = userAgent.match(/Version\/([\d.]+)/)?.[1] || "";
  }

  return {
    platformType,
    platformVersion,
  };
};
// export function addParamsURL(url, paramsObj) {
//   if (!/^https?:\/\/[^\s]+$/i.test(url)) {
//     return null;
//   }
//   let urlObj = new URL(url);
//   let params = new URLSearchParams(urlObj.search);
//   for (let key in paramsObj) {
//     params.set(key, paramsObj[key]);
//   }
//   urlObj.search = params.toString();
//   return urlObj.toString();
// }

export function addParamsURL(url, paramsObj) {
  try {
    if (!url) {
      throw Error();
    }
    let urlObj = new URL(url);
    let params = new URLSearchParams(urlObj.search);
    for (let key in paramsObj) {
      params.set(key, paramsObj[key]);
    }
    urlObj.search = params.toString();
    return urlObj.toString();
  } catch {
    return url;
  }
}

export function bytesToHumanReadable(bytes, precision = 2) {
  if (bytes == undefined || bytes == null) {
    return "-";
  }
  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB"];
  let size = bytes;
  let i = 0;

  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }

  return `${size.toFixed(precision)} ${units[i]}`;
}

export function getDeviceType() {
  const ua = navigator.userAgent;

  if (/tablet|ipad|playbook|silk|(android(?!.*mobi))/i.test(ua)) {
    return "Tablet";
  }

  if (/Mobile|iPhone|Android|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return "Mobile";
  }

  return "Desktop";
}

export const optionalFaceDetectionIdList = (
  process.env.REACT_APP_OPTIONAL_FACE_DETECTION || ""
)
  .split(" ")
  .filter(Boolean);

export const downloadQrImage = (base64String, eventDetails) => {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "image/png" }); // Adjust the MIME type if needed

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${eventDetails.name}_qr.png`; // Set the desired filename
  document.body.appendChild(link);
  link.click();
};

export const createWhatsAppLink = (message) => {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
};
export function isValidYYYYMMDD(dateStr) {
  const regex = /^\d{4}\/\d{2}\/\d{2}$/;
  if (!regex.test(dateStr)) return false;

  const [yyyy, mm, dd] = dateStr.split("/").map(Number);

  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;

  const date = new Date(yyyy, mm - 1, dd);

  return (
    date.getFullYear() === yyyy &&
    date.getMonth() === mm - 1 &&
    date.getDate() === dd
  );
}

export function isValidDateRange(startDate, endDate) {
  // Must match YYYY/MM/DD
  const dateRegex = /^\d{4}\/\d{2}\/\d{2}$/;

  if (!dateRegex.test(startDate) || !dateRegex.test(endDate)) {
    return false;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Check for Invalid Date
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return false;
  }

  return start <= end;
}
// export const countryPhoneCodes = [
//   {
//     name: "India",
//     dial_code: "+91",
//     code: "IN",
//   },
//   {
//     name: "Afghanistan",
//     dial_code: "+93",
//     code: "AF",
//   },
//   {
//     name: "Aland Islands",
//     dial_code: "+358",
//     code: "AX",
//   },
//   {
//     name: "Albania",
//     dial_code: "+355",
//     code: "AL",
//   },
//   {
//     name: "Algeria",
//     dial_code: "+213",
//     code: "DZ",
//   },
//   {
//     name: "AmericanSamoa",
//     dial_code: "+1684",
//     code: "AS",
//   },
//   {
//     name: "Andorra",
//     dial_code: "+376",
//     code: "AD",
//   },
//   {
//     name: "Angola",
//     dial_code: "+244",
//     code: "AO",
//   },
//   {
//     name: "Anguilla",
//     dial_code: "+1264",
//     code: "AI",
//   },
//   {
//     name: "Antarctica",
//     dial_code: "+672",
//     code: "AQ",
//   },
//   {
//     name: "Antigua and Barbuda",
//     dial_code: "+1268",
//     code: "AG",
//   },
//   {
//     name: "Argentina",
//     dial_code: "+54",
//     code: "AR",
//   },
//   {
//     name: "Armenia",
//     dial_code: "+374",
//     code: "AM",
//   },
//   {
//     name: "Aruba",
//     dial_code: "+297",
//     code: "AW",
//   },
//   {
//     name: "Australia",
//     dial_code: "+61",
//     code: "AU",
//   },
//   {
//     name: "Austria",
//     dial_code: "+43",
//     code: "AT",
//   },
//   {
//     name: "Azerbaijan",
//     dial_code: "+994",
//     code: "AZ",
//   },
//   {
//     name: "Bahamas",
//     dial_code: "+1242",
//     code: "BS",
//   },
//   {
//     name: "Bahrain",
//     dial_code: "+973",
//     code: "BH",
//   },
//   {
//     name: "Bangladesh",
//     dial_code: "+880",
//     code: "BD",
//   },
//   {
//     name: "Barbados",
//     dial_code: "+1246",
//     code: "BB",
//   },
//   {
//     name: "Belarus",
//     dial_code: "+375",
//     code: "BY",
//   },
//   {
//     name: "Belgium",
//     dial_code: "+32",
//     code: "BE",
//   },
//   {
//     name: "Belize",
//     dial_code: "+501",
//     code: "BZ",
//   },
//   {
//     name: "Benin",
//     dial_code: "+229",
//     code: "BJ",
//   },
//   {
//     name: "Bermuda",
//     dial_code: "+1441",
//     code: "BM",
//   },
//   {
//     name: "Bhutan",
//     dial_code: "+975",
//     code: "BT",
//   },
//   {
//     name: "Bolivia, Plurinational State of",
//     dial_code: "+591",
//     code: "BO",
//   },
//   {
//     name: "Bosnia and Herzegovina",
//     dial_code: "+387",
//     code: "BA",
//   },
//   {
//     name: "Botswana",
//     dial_code: "+267",
//     code: "BW",
//   },
//   {
//     name: "Brazil",
//     dial_code: "+55",
//     code: "BR",
//   },
//   {
//     name: "British Indian Ocean Territory",
//     dial_code: "+246",
//     code: "IO",
//   },
//   {
//     name: "Brunei Darussalam",
//     dial_code: "+673",
//     code: "BN",
//   },
//   {
//     name: "Bulgaria",
//     dial_code: "+359",
//     code: "BG",
//   },
//   {
//     name: "Burkina Faso",
//     dial_code: "+226",
//     code: "BF",
//   },
//   {
//     name: "Burundi",
//     dial_code: "+257",
//     code: "BI",
//   },
//   {
//     name: "Cambodia",
//     dial_code: "+855",
//     code: "KH",
//   },
//   {
//     name: "Cameroon",
//     dial_code: "+237",
//     code: "CM",
//   },
//   {
//     name: "Canada",
//     dial_code: "+1",
//     code: "CA",
//   },
//   {
//     name: "Cape Verde",
//     dial_code: "+238",
//     code: "CV",
//   },
//   {
//     name: "Cayman Islands",
//     dial_code: "+ 345",
//     code: "KY",
//   },
//   {
//     name: "Central African Republic",
//     dial_code: "+236",
//     code: "CF",
//   },
//   {
//     name: "Chad",
//     dial_code: "+235",
//     code: "TD",
//   },
//   {
//     name: "Chile",
//     dial_code: "+56",
//     code: "CL",
//   },
//   {
//     name: "China",
//     dial_code: "+86",
//     code: "CN",
//   },
//   {
//     name: "Christmas Island",
//     dial_code: "+61",
//     code: "CX",
//   },
//   {
//     name: "Cocos (Keeling) Islands",
//     dial_code: "+61",
//     code: "CC",
//   },
//   {
//     name: "Colombia",
//     dial_code: "+57",
//     code: "CO",
//   },
//   {
//     name: "Comoros",
//     dial_code: "+269",
//     code: "KM",
//   },
//   {
//     name: "Congo",
//     dial_code: "+242",
//     code: "CG",
//   },
//   {
//     name: "Congo, The Democratic Republic of the Congo",
//     dial_code: "+243",
//     code: "CD",
//   },
//   {
//     name: "Cook Islands",
//     dial_code: "+682",
//     code: "CK",
//   },
//   {
//     name: "Costa Rica",
//     dial_code: "+506",
//     code: "CR",
//   },
//   {
//     name: "Cote d'Ivoire",
//     dial_code: "+225",
//     code: "CI",
//   },
//   {
//     name: "Croatia",
//     dial_code: "+385",
//     code: "HR",
//   },
//   {
//     name: "Cuba",
//     dial_code: "+53",
//     code: "CU",
//   },
//   {
//     name: "Cyprus",
//     dial_code: "+357",
//     code: "CY",
//   },
//   {
//     name: "Czech Republic",
//     dial_code: "+420",
//     code: "CZ",
//   },
//   {
//     name: "Denmark",
//     dial_code: "+45",
//     code: "DK",
//   },
//   {
//     name: "Djibouti",
//     dial_code: "+253",
//     code: "DJ",
//   },
//   {
//     name: "Dominica",
//     dial_code: "+1767",
//     code: "DM",
//   },
//   {
//     name: "Dominican Republic",
//     dial_code: "+1849",
//     code: "DO",
//   },
//   {
//     name: "Ecuador",
//     dial_code: "+593",
//     code: "EC",
//   },
//   {
//     name: "Egypt",
//     dial_code: "+20",
//     code: "EG",
//   },
//   {
//     name: "El Salvador",
//     dial_code: "+503",
//     code: "SV",
//   },
//   {
//     name: "Equatorial Guinea",
//     dial_code: "+240",
//     code: "GQ",
//   },
//   {
//     name: "Eritrea",
//     dial_code: "+291",
//     code: "ER",
//   },
//   {
//     name: "Estonia",
//     dial_code: "+372",
//     code: "EE",
//   },
//   {
//     name: "Ethiopia",
//     dial_code: "+251",
//     code: "ET",
//   },
//   {
//     name: "Falkland Islands (Malvinas)",
//     dial_code: "+500",
//     code: "FK",
//   },
//   {
//     name: "Faroe Islands",
//     dial_code: "+298",
//     code: "FO",
//   },
//   {
//     name: "Fiji",
//     dial_code: "+679",
//     code: "FJ",
//   },
//   {
//     name: "Finland",
//     dial_code: "+358",
//     code: "FI",
//   },
//   {
//     name: "France",
//     dial_code: "+33",
//     code: "FR",
//   },
//   {
//     name: "French Guiana",
//     dial_code: "+594",
//     code: "GF",
//   },
//   {
//     name: "French Polynesia",
//     dial_code: "+689",
//     code: "PF",
//   },
//   {
//     name: "Gabon",
//     dial_code: "+241",
//     code: "GA",
//   },
//   {
//     name: "Gambia",
//     dial_code: "+220",
//     code: "GM",
//   },
//   {
//     name: "Georgia",
//     dial_code: "+995",
//     code: "GE",
//   },
//   {
//     name: "Germany",
//     dial_code: "+49",
//     code: "DE",
//   },
//   {
//     name: "Ghana",
//     dial_code: "+233",
//     code: "GH",
//   },
//   {
//     name: "Gibraltar",
//     dial_code: "+350",
//     code: "GI",
//   },
//   {
//     name: "Greece",
//     dial_code: "+30",
//     code: "GR",
//   },
//   {
//     name: "Greenland",
//     dial_code: "+299",
//     code: "GL",
//   },
//   {
//     name: "Grenada",
//     dial_code: "+1473",
//     code: "GD",
//   },
//   {
//     name: "Guadeloupe",
//     dial_code: "+590",
//     code: "GP",
//   },
//   {
//     name: "Guam",
//     dial_code: "+1671",
//     code: "GU",
//   },
//   {
//     name: "Guatemala",
//     dial_code: "+502",
//     code: "GT",
//   },
//   {
//     name: "Guernsey",
//     dial_code: "+44",
//     code: "GG",
//   },
//   {
//     name: "Guinea",
//     dial_code: "+224",
//     code: "GN",
//   },
//   {
//     name: "Guinea-Bissau",
//     dial_code: "+245",
//     code: "GW",
//   },
//   {
//     name: "Guyana",
//     dial_code: "+595",
//     code: "GY",
//   },
//   {
//     name: "Haiti",
//     dial_code: "+509",
//     code: "HT",
//   },
//   {
//     name: "Holy See (Vatican City State)",
//     dial_code: "+379",
//     code: "VA",
//   },
//   {
//     name: "Honduras",
//     dial_code: "+504",
//     code: "HN",
//   },
//   {
//     name: "Hong Kong",
//     dial_code: "+852",
//     code: "HK",
//   },
//   {
//     name: "Hungary",
//     dial_code: "+36",
//     code: "HU",
//   },
//   {
//     name: "Iceland",
//     dial_code: "+354",
//     code: "IS",
//   },
//   {
//     name: "India",
//     dial_code: "+91",
//     code: "IN",
//   },
//   {
//     name: "Indonesia",
//     dial_code: "+62",
//     code: "ID",
//   },
//   {
//     name: "Iran, Islamic Republic of Persian Gulf",
//     dial_code: "+98",
//     code: "IR",
//   },
//   {
//     name: "Iraq",
//     dial_code: "+964",
//     code: "IQ",
//   },
//   {
//     name: "Ireland",
//     dial_code: "+353",
//     code: "IE",
//   },
//   {
//     name: "Isle of Man",
//     dial_code: "+44",
//     code: "IM",
//   },
//   {
//     name: "Israel",
//     dial_code: "+972",
//     code: "IL",
//   },
//   {
//     name: "Italy",
//     dial_code: "+39",
//     code: "IT",
//   },
//   {
//     name: "Jamaica",
//     dial_code: "+1876",
//     code: "JM",
//   },
//   {
//     name: "Japan",
//     dial_code: "+81",
//     code: "JP",
//   },
//   {
//     name: "Jersey",
//     dial_code: "+44",
//     code: "JE",
//   },
//   {
//     name: "Jordan",
//     dial_code: "+962",
//     code: "JO",
//   },
//   {
//     name: "Kazakhstan",
//     dial_code: "+77",
//     code: "KZ",
//   },
//   {
//     name: "Kenya",
//     dial_code: "+254",
//     code: "KE",
//   },
//   {
//     name: "Kiribati",
//     dial_code: "+686",
//     code: "KI",
//   },
//   {
//     name: "Korea, Democratic People's Republic of Korea",
//     dial_code: "+850",
//     code: "KP",
//   },
//   {
//     name: "Korea, Republic of South Korea",
//     dial_code: "+82",
//     code: "KR",
//   },
//   {
//     name: "Kuwait",
//     dial_code: "+965",
//     code: "KW",
//   },
//   {
//     name: "Kyrgyzstan",
//     dial_code: "+996",
//     code: "KG",
//   },
//   {
//     name: "Laos",
//     dial_code: "+856",
//     code: "LA",
//   },
//   {
//     name: "Latvia",
//     dial_code: "+371",
//     code: "LV",
//   },
//   {
//     name: "Lebanon",
//     dial_code: "+961",
//     code: "LB",
//   },
//   {
//     name: "Lesotho",
//     dial_code: "+266",
//     code: "LS",
//   },
//   {
//     name: "Liberia",
//     dial_code: "+231",
//     code: "LR",
//   },
//   {
//     name: "Libyan Arab Jamahiriya",
//     dial_code: "+218",
//     code: "LY",
//   },
//   {
//     name: "Liechtenstein",
//     dial_code: "+423",
//     code: "LI",
//   },
//   {
//     name: "Lithuania",
//     dial_code: "+370",
//     code: "LT",
//   },
//   {
//     name: "Luxembourg",
//     dial_code: "+352",
//     code: "LU",
//   },
//   {
//     name: "Macao",
//     dial_code: "+853",
//     code: "MO",
//   },
//   {
//     name: "Macedonia",
//     dial_code: "+389",
//     code: "MK",
//   },
//   {
//     name: "Madagascar",
//     dial_code: "+261",
//     code: "MG",
//   },
//   {
//     name: "Malawi",
//     dial_code: "+265",
//     code: "MW",
//   },
//   {
//     name: "Malaysia",
//     dial_code: "+60",
//     code: "MY",
//   },
//   {
//     name: "Maldives",
//     dial_code: "+960",
//     code: "MV",
//   },
//   {
//     name: "Mali",
//     dial_code: "+223",
//     code: "ML",
//   },
//   {
//     name: "Malta",
//     dial_code: "+356",
//     code: "MT",
//   },
//   {
//     name: "Marshall Islands",
//     dial_code: "+692",
//     code: "MH",
//   },
//   {
//     name: "Martinique",
//     dial_code: "+596",
//     code: "MQ",
//   },
//   {
//     name: "Mauritania",
//     dial_code: "+222",
//     code: "MR",
//   },
//   {
//     name: "Mauritius",
//     dial_code: "+230",
//     code: "MU",
//   },
//   {
//     name: "Mayotte",
//     dial_code: "+262",
//     code: "YT",
//   },
//   {
//     name: "Mexico",
//     dial_code: "+52",
//     code: "MX",
//   },
//   {
//     name: "Micronesia, Federated States of Micronesia",
//     dial_code: "+691",
//     code: "FM",
//   },
//   {
//     name: "Moldova",
//     dial_code: "+373",
//     code: "MD",
//   },
//   {
//     name: "Monaco",
//     dial_code: "+377",
//     code: "MC",
//   },
//   {
//     name: "Mongolia",
//     dial_code: "+976",
//     code: "MN",
//   },
//   {
//     name: "Montenegro",
//     dial_code: "+382",
//     code: "ME",
//   },
//   {
//     name: "Montserrat",
//     dial_code: "+1664",
//     code: "MS",
//   },
//   {
//     name: "Morocco",
//     dial_code: "+212",
//     code: "MA",
//   },
//   {
//     name: "Mozambique",
//     dial_code: "+258",
//     code: "MZ",
//   },
//   {
//     name: "Myanmar",
//     dial_code: "+95",
//     code: "MM",
//   },
//   {
//     name: "Namibia",
//     dial_code: "+264",
//     code: "NA",
//   },
//   {
//     name: "Nauru",
//     dial_code: "+674",
//     code: "NR",
//   },
//   {
//     name: "Nepal",
//     dial_code: "+977",
//     code: "NP",
//   },
//   {
//     name: "Netherlands",
//     dial_code: "+31",
//     code: "NL",
//   },
//   {
//     name: "Netherlands Antilles",
//     dial_code: "+599",
//     code: "AN",
//   },
//   {
//     name: "New Caledonia",
//     dial_code: "+687",
//     code: "NC",
//   },
//   {
//     name: "New Zealand",
//     dial_code: "+64",
//     code: "NZ",
//   },
//   {
//     name: "Nicaragua",
//     dial_code: "+505",
//     code: "NI",
//   },
//   {
//     name: "Niger",
//     dial_code: "+227",
//     code: "NE",
//   },
//   {
//     name: "Nigeria",
//     dial_code: "+234",
//     code: "NG",
//   },
//   {
//     name: "Niue",
//     dial_code: "+683",
//     code: "NU",
//   },
//   {
//     name: "Norfolk Island",
//     dial_code: "+672",
//     code: "NF",
//   },
//   {
//     name: "Northern Mariana Islands",
//     dial_code: "+1670",
//     code: "MP",
//   },
//   {
//     name: "Norway",
//     dial_code: "+47",
//     code: "NO",
//   },
//   {
//     name: "Oman",
//     dial_code: "+968",
//     code: "OM",
//   },
//   {
//     name: "Pakistan",
//     dial_code: "+92",
//     code: "PK",
//   },
//   {
//     name: "Palau",
//     dial_code: "+680",
//     code: "PW",
//   },
//   {
//     name: "Palestinian Territory, Occupied",
//     dial_code: "+970",
//     code: "PS",
//   },
//   {
//     name: "Panama",
//     dial_code: "+507",
//     code: "PA",
//   },
//   {
//     name: "Papua New Guinea",
//     dial_code: "+675",
//     code: "PG",
//   },
//   {
//     name: "Paraguay",
//     dial_code: "+595",
//     code: "PY",
//   },
//   {
//     name: "Peru",
//     dial_code: "+51",
//     code: "PE",
//   },
//   {
//     name: "Philippines",
//     dial_code: "+63",
//     code: "PH",
//   },
//   {
//     name: "Pitcairn",
//     dial_code: "+872",
//     code: "PN",
//   },
//   {
//     name: "Poland",
//     dial_code: "+48",
//     code: "PL",
//   },
//   {
//     name: "Portugal",
//     dial_code: "+351",
//     code: "PT",
//   },
//   {
//     name: "Puerto Rico",
//     dial_code: "+1939",
//     code: "PR",
//   },
//   {
//     name: "Qatar",
//     dial_code: "+974",
//     code: "QA",
//   },
//   {
//     name: "Romania",
//     dial_code: "+40",
//     code: "RO",
//   },
//   {
//     name: "Russia",
//     dial_code: "+7",
//     code: "RU",
//   },
//   {
//     name: "Rwanda",
//     dial_code: "+250",
//     code: "RW",
//   },
//   {
//     name: "Reunion",
//     dial_code: "+262",
//     code: "RE",
//   },
//   {
//     name: "Saint Barthelemy",
//     dial_code: "+590",
//     code: "BL",
//   },
//   {
//     name: "Saint Helena, Ascension and Tristan Da Cunha",
//     dial_code: "+290",
//     code: "SH",
//   },
//   {
//     name: "Saint Kitts and Nevis",
//     dial_code: "+1869",
//     code: "KN",
//   },
//   {
//     name: "Saint Lucia",
//     dial_code: "+1758",
//     code: "LC",
//   },
//   {
//     name: "Saint Martin",
//     dial_code: "+590",
//     code: "MF",
//   },
//   {
//     name: "Saint Pierre and Miquelon",
//     dial_code: "+508",
//     code: "PM",
//   },
//   {
//     name: "Saint Vincent and the Grenadines",
//     dial_code: "+1784",
//     code: "VC",
//   },
//   {
//     name: "Samoa",
//     dial_code: "+685",
//     code: "WS",
//   },
//   {
//     name: "San Marino",
//     dial_code: "+378",
//     code: "SM",
//   },
//   {
//     name: "Sao Tome and Principe",
//     dial_code: "+239",
//     code: "ST",
//   },
//   {
//     name: "Saudi Arabia",
//     dial_code: "+966",
//     code: "SA",
//   },
//   {
//     name: "Senegal",
//     dial_code: "+221",
//     code: "SN",
//   },
//   {
//     name: "Serbia",
//     dial_code: "+381",
//     code: "RS",
//   },
//   {
//     name: "Seychelles",
//     dial_code: "+248",
//     code: "SC",
//   },
//   {
//     name: "Sierra Leone",
//     dial_code: "+232",
//     code: "SL",
//   },
//   {
//     name: "Singapore",
//     dial_code: "+65",
//     code: "SG",
//   },
//   {
//     name: "Slovakia",
//     dial_code: "+421",
//     code: "SK",
//   },
//   {
//     name: "Slovenia",
//     dial_code: "+386",
//     code: "SI",
//   },
//   {
//     name: "Solomon Islands",
//     dial_code: "+677",
//     code: "SB",
//   },
//   {
//     name: "Somalia",
//     dial_code: "+252",
//     code: "SO",
//   },
//   {
//     name: "South Africa",
//     dial_code: "+27",
//     code: "ZA",
//   },
//   {
//     name: "South Sudan",
//     dial_code: "+211",
//     code: "SS",
//   },
//   {
//     name: "South Georgia and the South Sandwich Islands",
//     dial_code: "+500",
//     code: "GS",
//   },
//   {
//     name: "Spain",
//     dial_code: "+34",
//     code: "ES",
//   },
//   {
//     name: "Sri Lanka",
//     dial_code: "+94",
//     code: "LK",
//   },
//   {
//     name: "Sudan",
//     dial_code: "+249",
//     code: "SD",
//   },
//   {
//     name: "Suriname",
//     dial_code: "+597",
//     code: "SR",
//   },
//   {
//     name: "Svalbard and Jan Mayen",
//     dial_code: "+47",
//     code: "SJ",
//   },
//   {
//     name: "Swaziland",
//     dial_code: "+268",
//     code: "SZ",
//   },
//   {
//     name: "Sweden",
//     dial_code: "+46",
//     code: "SE",
//   },
//   {
//     name: "Switzerland",
//     dial_code: "+41",
//     code: "CH",
//   },
//   {
//     name: "Syrian Arab Republic",
//     dial_code: "+963",
//     code: "SY",
//   },
//   {
//     name: "Taiwan",
//     dial_code: "+886",
//     code: "TW",
//   },
//   {
//     name: "Tajikistan",
//     dial_code: "+992",
//     code: "TJ",
//   },
//   {
//     name: "Tanzania, United Republic of Tanzania",
//     dial_code: "+255",
//     code: "TZ",
//   },
//   {
//     name: "Thailand",
//     dial_code: "+66",
//     code: "TH",
//   },
//   {
//     name: "Timor-Leste",
//     dial_code: "+670",
//     code: "TL",
//   },
//   {
//     name: "Togo",
//     dial_code: "+228",
//     code: "TG",
//   },
//   {
//     name: "Tokelau",
//     dial_code: "+690",
//     code: "TK",
//   },
//   {
//     name: "Tonga",
//     dial_code: "+676",
//     code: "TO",
//   },
//   {
//     name: "Trinidad and Tobago",
//     dial_code: "+1868",
//     code: "TT",
//   },
//   {
//     name: "Tunisia",
//     dial_code: "+216",
//     code: "TN",
//   },
//   {
//     name: "Turkey",
//     dial_code: "+90",
//     code: "TR",
//   },
//   {
//     name: "Turkmenistan",
//     dial_code: "+993",
//     code: "TM",
//   },
//   {
//     name: "Turks and Caicos Islands",
//     dial_code: "+1649",
//     code: "TC",
//   },
//   {
//     name: "Tuvalu",
//     dial_code: "+688",
//     code: "TV",
//   },
//   {
//     name: "Uganda",
//     dial_code: "+256",
//     code: "UG",
//   },
//   {
//     name: "Ukraine",
//     dial_code: "+380",
//     code: "UA",
//   },
//   {
//     name: "United Arab Emirates",
//     dial_code: "+971",
//     code: "AE",
//   },
//   {
//     name: "United Kingdom",
//     dial_code: "+44",
//     code: "GB",
//   },
//   {
//     name: "United States",
//     dial_code: "+1",
//     code: "US",
//   },
//   {
//     name: "Uruguay",
//     dial_code: "+598",
//     code: "UY",
//   },
//   {
//     name: "Uzbekistan",
//     dial_code: "+998",
//     code: "UZ",
//   },
//   {
//     name: "Vanuatu",
//     dial_code: "+678",
//     code: "VU",
//   },
//   {
//     name: "Venezuela, Bolivarian Republic of Venezuela",
//     dial_code: "+58",
//     code: "VE",
//   },
//   {
//     name: "Vietnam",
//     dial_code: "+84",
//     code: "VN",
//   },
//   {
//     name: "Virgin Islands, British",
//     dial_code: "+1284",
//     code: "VG",
//   },
//   {
//     name: "Virgin Islands, U.S.",
//     dial_code: "+1340",
//     code: "VI",
//   },
//   {
//     name: "Wallis and Futuna",
//     dial_code: "+681",
//     code: "WF",
//   },
//   {
//     name: "Yemen",
//     dial_code: "+967",
//     code: "YE",
//   },
//   {
//     name: "Zambia",
//     dial_code: "+260",
//     code: "ZM",
//   },
//   {
//     name: "Zimbabwe",
//     dial_code: "+263",
//     code: "ZW",
//   },
// ];

export const countryPhoneCodes = [
  { name: "India", dial_code: "+91", code: "IN" },
  { name: "Austria", dial_code: "+43", code: "AT" },
  { name: "Australia", dial_code: "+61", code: "AU" },
  { name: "Bahrain", dial_code: "+973", code: "BH" },
  { name: "Belgium", dial_code: "+32", code: "BE" },
  { name: "Brazil", dial_code: "+55", code: "BR" },
  { name: "Canada", dial_code: "+1", code: "CA" },
  { name: "Czech Republic", dial_code: "+420", code: "CZ" },
  { name: "Denmark", dial_code: "+45", code: "DK" },
  { name: "Egypt", dial_code: "+20", code: "EG" },
  { name: "Estonia", dial_code: "+372", code: "EE" },
  { name: "Finland", dial_code: "+358", code: "FI" },
  { name: "France", dial_code: "+33", code: "FR" },
  { name: "Germany", dial_code: "+49", code: "DE" },
  { name: "Greece", dial_code: "+30", code: "GR" },
  { name: "Hong Kong", dial_code: "+852", code: "HK" },
  { name: "Hungary", dial_code: "+36", code: "HU" },
  { name: "Iceland", dial_code: "+354", code: "IS" },
  { name: "Ireland", dial_code: "+353", code: "IE" },
  { name: "Israel", dial_code: "+972", code: "IL" },
  { name: "Italy", dial_code: "+39", code: "IT" },
  { name: "Japan", dial_code: "+81", code: "JP" },
  { name: "Korea, South", dial_code: "+82", code: "KR" },
  { name: "Kuwait", dial_code: "+965", code: "KW" },
  { name: "Luxembourg", dial_code: "+352", code: "LU" },
  { name: "Mauritius", dial_code: "+230", code: "MU" },
  { name: "Monaco", dial_code: "+377", code: "MC" },
  { name: "Netherlands", dial_code: "+31", code: "NL" },
  { name: "New Zealand", dial_code: "+64", code: "NZ" },
  { name: "Norway", dial_code: "+47", code: "NO" },
  { name: "Oman", dial_code: "+968", code: "OM" },
  { name: "Portugal", dial_code: "+351", code: "PT" },
  { name: "Saudi Arabia", dial_code: "+966", code: "SA" },
  { name: "Singapore", dial_code: "+65", code: "SG" },
  { name: "South Africa", dial_code: "+27", code: "ZA" },
  { name: "Spain", dial_code: "+34", code: "ES" },
  { name: "Sri Lanka", dial_code: "+94", code: "LK" },
  { name: "Sweden", dial_code: "+46", code: "SE" },
  { name: "Switzerland", dial_code: "+41", code: "CH" },
  { name: "United Arab Emirates", dial_code: "+971", code: "AE" },
  { name: "United Kingdom", dial_code: "+44", code: "GB" },
  { name: "United States", dial_code: "+1", code: "US" },
];
